module.exports = __webpack_public_path__ + "static/media/rf7.31970f35.jpg";